import React, { useCallback, useEffect, useState } from 'react';
import './addRegion.css';
import axios from 'axios';
import Select from 'react-select';
import baseConfig from '../../../config/config';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchGPUData, getDistinctDataThroughSingleApi, } from '../../../redux/actions/actions';
function AddRegion(props) {
    const dispatch = useDispatch();
    const [selectedArray, setSelectedArray] = React.useState("");
    const [gpuInputValues, setGpuInputValues] = useState({});
    const [isEdit] = React.useState(props.data.edit);
    const [regionData, setRegionData] = useState([])
    const [regionError, setRegionError] = React.useState('')
    const [gpuError, setGpuError] = React.useState('')
    const [label, setLable] = useState([])
    const [selectedGPUs, setSelectedGPUs] = useState([]);
    const [gpuInputErrors, setGpuInputErrors] = useState({});
    const [updating, setUpdating] = useState(false);
    const [availableGPUsForRegion, setAvailableGPUsForRegion] = useState([]);
    const isGPUDataLoading = useSelector(store => store.GPUData.isGPUDataLoading);
    const isGPUDataLoaded = useSelector(store => store.GPUData.isGPUDataLoaded);
    const GPUData = useSelector(store => store.GPUData.GPUData !== undefined ? store.GPUData.GPUData : []);
    const navigate = useNavigate();
    const gpuWiseRegionData = useSelector(store => store.GPUData.gpuWiseRegionData !== undefined ? store.GPUData.gpuWiseRegionData : []);
    const isDistinctDataThroughSingleApiLoaded = useSelector(
        (store) =>
            store.distinctDataThroughSingleApi.isDistinctDataThroughSingleApiLoaded
    );
    const isDistinctDataThroughSingleApiLoading = useSelector(
        (store) =>
            store.distinctDataThroughSingleApi.isDistinctDataThroughSingleApiLoading
    );
    const DistinctDataThroughSingleApi = useSelector(store => store.distinctDataThroughSingleApi.distinctDataThroughSingleApi);
    const GPUs_Data = useSelector(store => store.distinctDataThroughSingleApi.distinctDataThroughSingleApi.GPU);

    function showToast(message, status) {

        const toaster = document.createElement('div');
        toaster.className = `toaster ${status}-toaster`;
        toaster.style.position = 'fixed';
        toaster.style.top = '5%';
        toaster.style.left = '50%';
        toaster.style.transform = 'translateX(-50%)';

        toaster.style.height = '35px';
        toaster.style.maxWidth = '300px';
        toaster.style.zIndex = 1000;
        toaster.innerText = message;

        document.body.appendChild(toaster);
        setTimeout(() => {
            toaster.style.display = 'none';
        }, 5000);
    }

    const handleGPUSelect = (selectedOptions) => {
        const currentValues = { ...gpuInputValues };
        const filteredOptions = selectedOptions.filter(gpu => 
            !availableGPUsForRegion.includes(gpu.value)
        );
        setSelectedGPUs(filteredOptions);
        setGpuError('');
        
        const newGpuInputValues = {};
        const newGpuInputErrors = {};
        
        filteredOptions.forEach(gpu => {
            newGpuInputValues[gpu.value] = currentValues[gpu.value] || 0;
            const value = currentValues[gpu.value] || 0;
            newGpuInputErrors[gpu.value] = value % 8 !== 0 ? "Value must be a multiple of 8" : "";
        });  
        setGpuInputValues(newGpuInputValues);
        setGpuInputErrors(newGpuInputErrors);
        const updatedArray = { ...selectedArray, Region: selectedArray?.Region };
        filteredOptions.forEach(gpu => {
            updatedArray[gpu.value] = newGpuInputValues[gpu.value];
        });

        const newLabels = ["Region", "GPUs", ...filteredOptions.map(gpu => gpu.value)];
        setLable(newLabels);
        setSelectedArray(updatedArray);
    };

    const handleInputChange = (e, lab, index) => {
        const newValue = e.target.value;
        const updatedArray = { ...selectedArray };
        const updatedGpuInputValues = { ...gpuInputValues };
        const updatedGpuInputErrors = { ...gpuInputErrors };

        if (lab === "Region") {
            updatedArray[lab] = newValue;
            checkAvailableGPUsForRegion(newValue);
            setSelectedGPUs([]);
            const newLabels = ["Region", "GPUs"];
            setLable(newLabels);
        } else {
            const parsedValue = newValue === "" ? 0 : parseInt(newValue, 10);
            updatedArray[lab] = parsedValue;
            updatedGpuInputValues[lab] = parsedValue;
            if (parsedValue % 8 !== 0) {
                updatedGpuInputErrors[lab] = "Value must be a multiple of 8";
            } else {
                updatedGpuInputErrors[lab] = "";
            }
        }

        setSelectedArray(updatedArray);
        setGpuInputValues(updatedGpuInputValues);
        setGpuInputErrors(updatedGpuInputErrors);
    };

    const checkAvailableGPUsForRegion = (regionName) => {
        if (!regionName || !gpuWiseRegionData) return;

        const availableGPUs = [];
        Object.keys(gpuWiseRegionData).forEach(gpuType => {
            if (gpuWiseRegionData[gpuType].includes(regionName)) {
                availableGPUs.push(gpuType);
            }
        });
        
        setAvailableGPUsForRegion(availableGPUs);
    };
    
    const hasGpuErrors = () => {
        if (Object.keys(gpuInputErrors).length === 0 && selectedGPUs.length > 0) {
            return false;
        }
        return Object.values(gpuInputErrors).some(error => error !== "") || Object.keys(gpuInputValues).length === 0;
    };

    React.useEffect(() => {
        if (DistinctDataThroughSingleApi?.RegionAllocatedOptions && DistinctDataThroughSingleApi.RegionAllocatedOptions.length > 0) {
            const initialLabels = ["Region"];
            const gpuLabels = ["GPUs"];
            const finalLabels = [...initialLabels, ...gpuLabels];

            setLable(finalLabels);
            const uniqueGBBRegionID = [];
            DistinctDataThroughSingleApi.RegionAllocatedOptions.forEach(region => {
                if (region?.Value && region.Value.trim() !== '') {
                    if (!uniqueGBBRegionID.includes(region.Value)) {
                        uniqueGBBRegionID.push(region.Value);
                    }
                }
            });


        }
    }, [DistinctDataThroughSingleApi, GPUData]);

    React.useEffect(() => {
        if (!isDistinctDataThroughSingleApiLoaded) {
            dispatch(getDistinctDataThroughSingleApi());
        }
    }, [isDistinctDataThroughSingleApiLoading])

    React.useEffect(() => {
        if (DistinctDataThroughSingleApi?.RegionAllocatedOptions) {
            setRegionData(DistinctDataThroughSingleApi.RegionAllocatedOptions);
        }
    }, [DistinctDataThroughSingleApi]);
    React.useEffect(() => {
        if (!isGPUDataLoaded) {
            dispatch(fetchGPUData());
        }
    }, [isGPUDataLoading]);

    React.useEffect(() => {
        if (isEdit && selectedArray?.Region) {
            checkAvailableGPUsForRegion(selectedArray.Region);
        }
    }, [gpuWiseRegionData, isEdit, selectedArray?.Region]);

    const handleEscapeKeyPress = useCallback((event) => {
        if (event.key === 'Escape') {
            closeModal()
        }
    }, []);

    useEffect(() => {
        document.addEventListener('keydown', handleEscapeKeyPress);

        return () => {
            document.removeEventListener('keydown', handleEscapeKeyPress);
        };
    }, [handleEscapeKeyPress]);

    function validate() {
        let isValid = true;

        if (!selectedArray || !selectedArray['Region']) {
            setRegionError('This is a mandatory field')
            isValid = false;
        } else {
            setRegionError('')
        }

        if (!isEdit && (!selectedGPUs || selectedGPUs.length === 0)) {
            setGpuError('Please select at least one GPU')
            isValid = false;
        } else {
            setGpuError('')
        }

        if (hasGpuErrors()) {
            isValid = false;
        }

        return isValid;
    }

    const update = async () => {
        if (validate()) {
            setUpdating(true);
            showToast(isEdit ? "Updating Region" : "Adding Region", 'warning');

            try {
                const gpuDataPayload = {};
                selectedGPUs.forEach(gpu => {
                    gpuDataPayload[gpu.value] = selectedArray.hasOwnProperty(gpu.value) 
                        ? selectedArray[gpu.value] 
                        : 0;
                });

                const addRegionPayload = {
                    "Region_Name": selectedArray.Region,
                    "GPUs": gpuDataPayload
                };
                let csrfToken=localStorage.getItem("csrfToken")

                const addRegionResponse = await axios.post(
                    baseConfig.apiBaseUrl + '/add/region',
                    addRegionPayload,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            "serviceid": sessionStorage.getItem("userToken"),
                            "X-CSRF-Token": csrfToken
                        },
                        withCredentials: true,
                    },
                );

                if (addRegionResponse.status === 200) {
                    props.handleModal();
                    showToast(addRegionResponse.data, 'success');
                    window.location.reload();
                } else {
                    navigate("/CapacityRoadMap");
                }
            } catch (error) {
                console.error("Error adding region:", error);
                showToast("Failed to add region", 'danger');
            }
        }
    };
    const closeModal = () => {
        props.handleModal()
    }

    const isSubmitDisabled = regionError !== '' || gpuError !== '' || updating || hasGpuErrors();

    const getGPUOptions = () => {
        if (!GPUs_Data) return [];
        
        return GPUs_Data.map(gpu => ({
            value: gpu.Value,
            label: gpu.Value,
            isDisabled: selectedArray?.Region && availableGPUsForRegion.length > 0 
                ? availableGPUsForRegion.includes(gpu.Value) 
                : false
        }));
    };

    return (
        <div className="modal-container-add">

            <div style={{ maxHeight: '80vh' }}>
                <div className="title-add">
                    {isEdit === true ?
                        <>
                            <b>Allocate GPUs</b>
                            <i
                                className="fa fa-times close-icon"
                                onClick={closeModal}
                            ></i>
                        </>
                        :
                        <> <b>Add New Region</b>
                            <i
                                className="fa fa-times close-icon"
                                onClick={closeModal}
                            ></i>
                        </>
                    }
                </div>
                <div className="grid-container-add">
                    {label && label.map((lab, index) => {
                        if (lab === "Region") {
                            return (
                                <div key={lab} className="grid-item-add">
                                    <div className="input-container-add">
                                        <label className="text-container-add">
                                            Region Name <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        {isEdit ? (
                                            <input
                                                placeholder="Enter Region Name"
                                                type="text"
                                                disabled={isEdit}
                                                value={selectedArray?.Region}
                                                style={{ width: '100%', cursor: 'not-allowed' }}
                                                className="custom-input-add"
                                                onChange={(e) => { handleInputChange(e, 'Region') }}
                                            />
                                        ) : (
                                            <div style={{ flexDirection: 'row', display: 'flex' }}>
                                                <input
                                                    placeholder="Choose / Enter Region Name"
                                                    type="text"
                                                    disabled={isEdit}
                                                    value={selectedArray?.Region}
                                                    style={{ width: '100%', cursor: isEdit ? 'not-allowed' : '' }}
                                                    className="custom-input-add"
                                                    onChange={(e) => { handleInputChange(e, 'Region') }}
                                                />
                                                <div id="filterDropdownDiv">
                                                    <select
                                                        name="filterDropDown"
                                                        id="filterDropDown"
                                                        disabled={isEdit}
                                                        onChange={(e) => { handleInputChange(e, 'Region') }}
                                                        style={{
                                                            width: '20px',
                                                            outline: 'none',
                                                            marginTop: '3px',
                                                            height: '32px',
                                                            cursor: isEdit ? 'not-allowed' : 'pointer'
                                                        }}
                                                    >
                                                        <option value="-1" selected="selected" disabled="disabled">
                                                            -- Select Region name --
                                                        </option>
                                                        {regionData
                                                            ?.filter(Region => Region.Key !== "" && Region.Value !== "") 
                                                            .map((Region) => (
                                                                <option key={Region.Key} value={Region.Value}>
                                                                    {Region.Value}
                                                                </option>
                                                            ))}

                                                    </select>
                                                </div>
                                            </div>
                                        )}
                                        <span style={{
                                            color: 'red',
                                            fontSize: '8px',
                                            display: 'block',
                                            marginTop: '3px'
                                        }}>
                                            {regionError}
                                        </span>
                                    </div>
                                </div>
                            );
                        }
                        if (lab === "GPUs") {
                            return (
                                <div key={lab} className="grid-item-add">
                                    <div className="input-container-add">
                                        <label className="text-container-add">
                                            Select GPUs <span style={{ color: 'red' }}>*</span>
                                        </label>
                                        <Select
                                            isMulti
                                            options={getGPUOptions()}
                                            onChange={handleGPUSelect}
                                            value={selectedGPUs}
                                            classNamePrefix="custom-select"
                                            isOptionDisabled={(option) => option.isDisabled}
                                            styles={{
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    maxHeight: '70px',
                                                    overflowY: 'auto'
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    color: state.isDisabled ? '#ccc' : '#333',
                                                    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                                                    backgroundColor: state.isDisabled 
                                                        ? '#f9f9f9' 
                                                        : state.isSelected 
                                                            ? '#e6f7ff' 
                                                            : state.isFocused 
                                                                ? '#f0f0f0' 
                                                                : null
                                                })
                                            }}
                                        />
                                        {gpuError && (
                                            <span style={{
                                                color: 'red',
                                                fontSize: '8px',
                                                display: 'block',
                                                marginTop: '3px'
                                            }}>
                                                {gpuError}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            );
                        }
                    })}
                </div>
                <div className="grid-container-add-gpus">
                    {label && label.map((lab, index) => {
                        if (index > 1 && !lab.includes("GBB Region")) {
                            return (
                                <div key={lab} className="grid-item-add">
                                    <div className="input-container-add-gpus">
                                        <label className="text-container-add">{lab}</label>
                                        <input
                                            type="number"
                                            placeholder={`Enter number for ${lab}`}
                                            className="custom-input-add"
                                            style={{ width: '100%' }}
                                            onChange={(e) => { handleInputChange(e, lab, index) }}
                                        />
                                        {gpuInputErrors[lab] && (
                                            <span style={{
                                                color: 'red',
                                                fontSize: '8px',
                                                display: 'block',
                                                marginTop: '3px',
                                               
                                            }}>
                                                {gpuInputErrors[lab]}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
                <hr className="divider-add" style={{ gridColumn: '1 / -1' }} />

                  
                <div className="buttons-container-add marginBottom">
                    <button
                        className="button-add button-go-back-add"
                        onClick={closeModal}
                    >
                        Cancel
                    </button>
                    <button
                        className="button-add button-confirm-add"
                        onClick={update}
                        disabled={isSubmitDisabled}
                        style={{
                            opacity: isSubmitDisabled ? 0.5 : 1
                        }}
                    >
                        Submit
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AddRegion;